"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Star = _interopRequireDefault(require("./Star"));
var _pixi = require("pixi.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StarWarp = exports["default"] = /*#__PURE__*/function (_Container) {
  function StarWarp(scene, w, h) {
    var _this;
    _classCallCheck(this, StarWarp);
    _this = _callSuper(this, StarWarp);
    // This is the manager for the stars, this deals will adding and removing stars as well as resetting their position
    _defineProperty(_this, "scene", void 0);
    _defineProperty(_this, "screenWidth", void 0);
    _defineProperty(_this, "screenHeight", void 0);
    _defineProperty(_this, "starAmount", void 0);
    _defineProperty(_this, "defaultForce", void 0);
    _defineProperty(_this, "force", void 0);
    _defineProperty(_this, "stars", void 0);
    _defineProperty(_this, "starsIdle", void 0);
    _defineProperty(_this, "alphaValue", void 0);
    _defineProperty(_this, "frequency", void 0);
    _defineProperty(_this, "color", void 0);
    _defineProperty(_this, "stop", void 0);
    _defineProperty(_this, "hideWarp", void 0);
    _defineProperty(_this, "lineWidth", void 0);
    _defineProperty(_this, "starWidth", void 0);
    _defineProperty(_this, "isIdle", void 0);
    _defineProperty(_this, "center", void 0);
    _defineProperty(_this, "randomiseColor", void 0);
    _defineProperty(_this, "skipToggle", void 0);
    _defineProperty(_this, "counter", void 0);
    _defineProperty(_this, "globalForce", void 0);
    _defineProperty(_this, "defaultLerpSpeed", void 0);
    _defineProperty(_this, "forceLerpSpeed", void 0);
    _defineProperty(_this, "warpTimeout", void 0);
    _defineProperty(_this, "startWarp", function (duration) {
      _this.isIdle = false;
      _this.forceLerpSpeed = _this.defaultLerpSpeed;
      _this.force = _this.defaultForce;
      if (duration) {
        _this.warpTimeout = setTimeout(function () {
          _this.stopWarp();
        }, duration);
      }
    });
    _defineProperty(_this, "stopWarp", function () {
      if (_this.warpTimeout) clearTimeout(_this.warpTimeout);
      _this.isIdle = true;
      _this.forceLerpSpeed = 0.6;
      _this.force = 0;
      for (var key in _this.stars) {
        if (Math.random() < 0.2) _this.stars[key].sprite.fx.visible = true;
      }
    });
    _this.scene = scene;
    _this.screenWidth = w;
    _this.screenHeight = h;
    _this.starAmount = 400;
    _this.defaultForce = 55;
    _this.force = _this.defaultForce;
    _this.stars = [];
    _this.starsIdle = [];
    _this.alphaValue = 1;
    _this.frequency = _this.starAmount;
    _this.color = 0xffffff;
    _this.stop = false;
    _this.hideWarp = false;
    _this.lineWidth = 3;
    _this.starWidth = 0.15;
    _this.isIdle = false;
    _this.center = {
      x: 0,
      y: 0
    };
    _this.interactiveChildren = false;
    _this.build();
    _this.x = _this.center.x;
    _this.y = _this.center.y;
    _this.randomiseColor = false;
    _this.skipToggle = false;
    return _this;
  }
  _inherits(StarWarp, _Container);
  return _createClass(StarWarp, [{
    key: "build",
    value: function build() {
      var _this2 = this;
      for (var i = 0; i < this.starAmount; i++) {
        var star = new _Star["default"](this);
        star.build();
        this.stars.push(star);
        this.addChild(star);
        this.randomizeStar(star);
        star.forceIdle = false;
      }
      for (var _i = 0; _i < this.starAmount / 2; _i++) {
        var _star = new _Star["default"](this);
        _star.build();
        this.starsIdle.push(_star);
        this.addChild(_star);
        this.randomizeStar(_star);
        _star.forceIdle = true;
        //    star.sprite.tint = 0x00ff00
        //    star.sprite.fx.tint = 0x00ff00
      }
      this.counter = 0;
      this.globalForce = 0;
      setTimeout(function () {
        _this2.stopWarp();
      }, 100);
      this.defaultLerpSpeed = 0.995;
      this.forceLerpSpeed = this.defaultLerpSpeed;
    }
  }, {
    key: "randomizeStar",
    value: function randomizeStar(star) {
      this.center.x = 0;
      this.center.y = 0;
      var angle = Math.random() * Math.PI * 2;
      var dist;
      if (this.screenHeight > this.screenWidth) {
        dist = Math.random() * (this.screenHeight / 2);
      } else {
        dist = Math.random() * (this.screenWidth / 2);
      }
      star.x = Math.cos(angle) * dist;
      star.y = Math.sin(angle) * dist;
      angle = Math.atan2(this.center.y - star.y, this.center.x - star.x) + Math.PI;
      star.force = 1;
      star.angle = angle;
      star.sprite.rotation = star.angle + Math.PI / 2;
      star.sprite.fx.rotation = -star.sprite.rotation;
      star.minScaleY = Math.random() * 0.03 + 0.01;
      star.sprite.fx.scale.set(star.minScaleY / star.sprite.scale.x * 5);
      star.sprite.scale.x = star.minScaleY;
      star.starterPos = {
        x: star.x,
        y: star.y
      };
    }
  }, {
    key: "update",
    value: function update() {
      if (this.starAmount > this.stars.length) {
        this.addStar();
      } else if (this.starAmount < this.stars.length) {
        this.removeStar();
      }
      if (this.stop) return;
      this.counter++;
      this.globalForce = this.lerp(this.force, this.globalForce, this.forceLerpSpeed);
      this.updateList(this.stars);
      this.updateList(this.starsIdle);
    }
  }, {
    key: "updateList",
    value: function updateList(list) {
      for (var i = 0; i < list.length; i++) {
        var element = list[i];
        element.update();
        if (element.x + 20 <= -(this.screenWidth / 2) || element.x - 20 > this.screenWidth / 2) {
          this.resetPosition(element);
        }
        if (element.y + 20 <= -(this.screenHeight / 2) || element.y - 20 > this.screenHeight / 2) {
          this.resetPosition(element);
        }
      }
    }
  }, {
    key: "resetPosition",
    value: function resetPosition(star) {
      star.alpha = 0;
      this.randomizeStar(star);
      star.reset(this.color, this.randomiseColor);
    }
  }, {
    key: "warpState",
    value: function warpState(state) {
      this.stop = state;
    }
  }, {
    key: "resize",
    value: function resize(hight, width) {
      this.screenWidth = width;
      this.screenHeight = hight;
      this.x = width / 2;
      this.y = hight / 2;
      this.center = {
        x: this.screenWidth / 2,
        y: this.screenWidth / 2
      };
      for (var key in this.starsIdle) {
        var element = this.starsIdle[key];
        this.randomizeStar(element);
      }
    }
  }, {
    key: "addStar",
    value: function addStar() {
      var star = new _Star["default"](this);
      star.build();
      this.stars.push(star);
      this.addChild(star);
      this.randomizeStar(star);
    }
  }, {
    key: "removeStar",
    value: function removeStar() {
      this.removeChild(this.stars[this.stars.length - 1]);
      this.stars.pop();
    }
  }, {
    key: "lerp",
    value: function lerp(v0, v1, t) {
      return v0 * (1 - t) + v1 * t;
    }
  }]);
}(_pixi.Container);
//# sourceMappingURL=StarWarp.js.map